import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategoryCards from './components/CategoryCards';
import ContentSections from './components/ContentSections';
import Footer from './components/Footer';
import ArticleCards from './components/ArticleCards';
import { WebSiteJsonLd, FaqJsonLd } from '@/components/base/SeoJsonLd';
import { faqItems } from '@/mocks/categories';

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <WebSiteJsonLd />
      <FaqJsonLd faqs={faqItems} />
      <Navbar />
      <HeroSection />
      <CategoryCards />
      <ContentSections />
      <ArticleCards />
      <Footer />
    </main>
  );
}